import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Link,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material'

import { buildCompaniesHouseSearchUrl } from './util'

export interface Props {
  applicantName: string
  value: boolean | null
  onChange: (value: boolean) => void
}

const CompanyNamedOfficerRadioGroup = ({ applicantName, value, onChange }: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value === 'true')
  }

  return (
    <Stack spacing={2} direction="row" justifyContent="space-between">
      <FormControl>
        <FormLabel id="company-named-officer-label">
          Is {applicantName} named as a company officer?
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="company-named-officer-label"
          name="company-named-officer"
          value={value === null ? undefined : value.toString()}
          onChange={handleChange}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
      <Box>
        <Link
          href={buildCompaniesHouseSearchUrl(applicantName)}
          target="_blank"
          rel="noreferrer noopener"
        >
          Search Companies House
        </Link>
      </Box>
    </Stack>
  )
}

export default CompanyNamedOfficerRadioGroup
